"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sample = void 0;
exports.sample = (iterable) => iterable[Math.floor(Math.random() * iterable.length)];
//# sourceMappingURL=sample.js.map